
export default {
  data() {
    return {
      title: "Privacy Policy | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
};
